module.exports = __webpack_public_path__ + "static/media/tn.50cd9101.svg";